import { withNamespaces } from "react-i18next";
import { RiErrorWarningLine } from "react-icons/ri";
import { Button } from "reactstrap";

const ChartError = ({ 
    t, 
    title,
    message,
    onRetry 
}) => (
    <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-4">
        <RiErrorWarningLine
            size={42}
            className="text-danger mb-3"
        />

        <h6 className="mb-2">
            {t(
                title || 'Failed to load chart data'
            )}
        </h6>

        <p className="text-muted mb-3">
            {t(
                message || 'An error occurred while fetching chart data.'
            )}
        </p>

        {onRetry && (
            <Button
                color="light"
                onClick={onRetry}
            >
                {t('Retry')}
            </Button>
        )}
    </div>
);

export default withNamespaces()(
    ChartError
);